export const IMAGE_CATEGORY = 'image';
export const AUDIO_CATEGORY = 'audio';
export const VIDEO_CATEGORY = 'video';